import axios from "axios";

export function subirArchivo(archivo) {
  try {
    const formData = new FormData();
    formData.append("file", archivo);
    const [nombre, extension] = archivo.name.split(".", 2);
    const nuevoNombre = `${nombre}_${Math.random()
      .toString(36)
      .substring(7)}.${extension}`;
    formData.append("nombre", nuevoNombre);
    axios.post("/api/archivos/", formData, {});
    return nuevoNombre;
  } catch {
    return null;
  }
}
